import React from 'react';
import { SVGProps } from './types';

const DropFilesIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M15 11.256v6.671m3.333-3.335h-6.666"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.25"
        d="M5.822 5.427H10m0 0h8.326c.005 0 .009.003.009.008v4.58M9.998 5.426L7.496 2.095h-5.82a.008.008 0 00-.01.008l.001 14.948c0 .005-.005.04 0 .04h8.341"
      />
    </svg>
  );
};

export { DropFilesIcon };
